/* eslint-disable camelcase */

const school_and_district = {};

export default school_and_district;
